import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { Amenity, HotelDetail } from "../../../Models";
import { getValueByLang } from "../../../Utils";
import {Dialog} from '../../common/MaterialDesignComponents';
import StaticMapComponent from "../../common/roomselection/StaticMapComponent";

interface Attrs{
    hotelDetails: HotelDetail
    messageProvider: MessageProvider
    onViewHotelLocationMap: () => void
    onViewImageSelected: () => void
}

export default function HotelOverviewComponent(): m.Component<Attrs> {
    let showingAmenityDialog = false;
    let showMoreGeneralPolicy = false;
    let showMoreCancellationPolicy = false;
    let showMoreTerms = false;

    return {
        oncreate(vnode){
            let cancellationPolicyElem = document.getElementById("cancellation-policy-content");
            if(cancellationPolicyElem!=null){
                showMoreCancellationPolicy = cancellationPolicyElem.offsetHeight+1< cancellationPolicyElem.scrollHeight;
                console.log(cancellationPolicyElem.offsetHeight+" "+ cancellationPolicyElem.scrollHeight+ " "+ showMoreCancellationPolicy);
            }
            let termsElem = document.getElementById("terms-content");
            if(termsElem!=null){
                showMoreTerms = termsElem.offsetHeight+1< termsElem.scrollHeight;
                console.log(termsElem.offsetHeight+" "+ termsElem.scrollHeight+ " "+ showMoreTerms);
            }
            let generalPolicyElem = document.getElementById("general-policy-content");
            if(generalPolicyElem!=null){
                showMoreGeneralPolicy = generalPolicyElem.offsetHeight+1< generalPolicyElem.scrollHeight;
                console.log(generalPolicyElem.offsetHeight+" "+ generalPolicyElem.scrollHeight+ " "+ showMoreGeneralPolicy);
            }
            
            m.redraw();
        },
        view(vnode){
            const {hotelDetails, messageProvider, onViewHotelLocationMap, onViewImageSelected} = vnode.attrs;

            let townName = hotelDetails.town!=null ? getValueByLang(hotelDetails.town.name, messageProvider.getCurrentLang())  : "";
            return  [             
                                     
                m("div", {
                    class: "row _no-gutters"
                }, [
                    m("div", { class: "col-md-7 pr-5" }, [
                        m("h3", getValueByLang(hotelDetails.name, messageProvider.getCurrentLang())),
                        m("p.text-muted", townName),
                    
                        m("div.my-5",[
                            m("h5", "Facilities"),
                            m("div.row mt-3", {}, [                                
                                hotelDetails.amenities.slice(0, 6).map(function(amenity){
                                    return m("div.col-6", 
                                        m(AmentityItem, {
                                            amenity: amenity, 
                                            messageProvider: messageProvider
                                        }))
                                })
                            ]),
                            hotelDetails.amenities.length>8?
                            m("div.text-info pt-1", {  
                                onclick: function(event){
                                    event.preventDefault();
                                    showingAmenityDialog = true;
                                }
                            },
                                m("span.clickable", messageProvider.get("see_all"))
                            )
                            :null,
                            m("div.mt-5 pr-2 d-flex",
                                m("i.bi bi-check2 text-success align-self-center"),
                                m("div.text-sm-left pl-2",messageProvider.interpolate("up_to_years_of_age", {years:hotelDetails.maxChildAge}))
                            ),
                            m("div.mt-5",
                                m("div.row", 
                                    m("div.col-12 d-flex", 
                                        m("i.bi bi-clock pr-2 align-self-center"),
                                        m("div.font-medium text-sm-left", "Check-In Time  :  from  "),
                                        m("div.text-right ml-1", hotelDetails.regulation.checkInCheckOutPolicy.checkInTime.en)
                                    ),
                                    
                                ),
                            ),
                            m("div.mt-2",
                                m("div.row", 
                                m("div.col-12 d-flex", 
                                    m("i.bi bi-clock pr-2 align-self-center"),
                                    m("div.font-medium text-sm-left", "Check-Out Time  :  until  "),
                                    m("div.text-right ml-1", hotelDetails.regulation.checkInCheckOutPolicy.checkOutTime.en)
                                )
                                ),
                            ),

                            (hotelDetails.valueAddedPromotion != null)?
                            m("div.mt-5",[
                                m("h5", "Value Added Promotions"),
                                m("div.row mt-3", 
                                    m("div.col d-flex", [
                                        m("i.fas fa-gift text-success pr-3 align-self-center"),
                                        m("div",getValueByLang(hotelDetails.valueAddedPromotion.fullMessage, messageProvider.getCurrentLang()))
                                    ])
                                )
                            ]):null
                        ])
                    ]),
                    m("div.col-md-5", [
                        m("div", 
                            m("iframe", {
                                class: "rounded-16",
                                src: (hotelDetails.geoLocation.googleMapUrl != null)? hotelDetails.geoLocation.googleMapUrl: "https://www.google.com/maps?q="+ hotelDetails.geoLocation.latitude + "," + hotelDetails.geoLocation.longitude + "&output=embed",
                                width: "100%",
                                height:"450",
                                style:"border:0;",
                                loading:"lazy",
                                referrerpolicy:"no-referrer-when-downgrade"
                            }),
                            /*m(StaticMapComponent, {
                                geoLocation: hotelDetails.geoLocation,
                                isDesktop: true,
                                onExpand: () => {
                                    onViewHotelLocationMap();
                                } 
                            })*/
                        ),
                        m("div.mt-2", "Address : "+getValueByLang(hotelDetails.address, messageProvider.getCurrentLang())),
                        
                        hotelDetails.nearbyPlaces.length>0?
                        m("div",[
                            m("h5.mt-5", "Nearby Attractions"),
                            m("div.row.mt-3", {}, [                                
                                hotelDetails.nearbyPlaces.map(function(place){
                                    return [ 
                                        m("div.col-sm-12 col-md-8 col-lg-8.mb-2 d-flex", [
                                            m("i.bi bi-geo-alt pr-1 text-muted align-self-center"),
                                            m("div.ml-3", {}, getValueByLang(place.name, messageProvider.getCurrentLang()))
                                        ]),                                  
                                        
                                        m("div.col-sm-12 col-md-4 col-lg-4.mb-2.text-right", "___ "+place.distanceInMiles + " miles")
                                    ]
                                })
                            ])
                        ]
                        
                        ):null

                        
                    ]),
                ]),

                m(Dialog, {
                    title: "Guaranteed Amenities",
                    isOpen: showingAmenityDialog,
                    onClose : () => {
                        showingAmenityDialog = false;
                    },
                    actionItems : [
                        {
                            label: "Ok",
                            onclick: () => {
                                showingAmenityDialog = false;
                            }
                        }
                    ]
                }, hotelDetails.amenities.map(function(amenity){
                    return m(AmentityItem, {
                        amenity: amenity, 
                        messageProvider: messageProvider
                    })
                })),

                
            ]
        }
    }
}

function AmentityItem() : m.Component<{amenity:Amenity, messageProvider: MessageProvider}> {
    return {
        view: (vnode) => 
            m("div.mb-2", {class: ""}, [
                m("img", {src: vnode.attrs.amenity.defaultIcon}),
                m("span.ml-3", {}, getValueByLang(vnode.attrs.amenity.label, vnode.attrs.messageProvider.getCurrentLang()))
            ])
    }
}

